import { render, staticRenderFns } from "./resolved-order-list.vue?vue&type=template&id=8d6d6098&"
import script from "./resolved-order-list.vue?vue&type=script&lang=js&"
export * from "./resolved-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports